/**
 * @author gyb(mocheer) 
 * @email mocheer@foxmail.com
 * @since 2017.6.13
 * @see https://github.com/gtramontina/draggable.js
 */
let $ = T;
let { document } = self;
let { DomUtil } = L;
/**
 * drag
 * 用于tooltip拖拽
 */
$.fn.draggable = function (options) {
  let dragging = this.dragging = this.dragging || new DragHandler();
  dragging.el = this[0];
  dragging.setOptions(options);
  dragging.enable();
  return dragging;
}
//
let inPixels = val => val + 'px';
/**
 * 
 */
class DragHandler extends $.Action {
  el;
  constructor() {
    super();
    this.drag = this.drag.bind(this);
    this.removeEvents = this.removeEvents.bind(this);
  }
  /**
   * 
   */
  options = {
    zIndex: 10
  }
  /**
   * 
   * @param {*} options 
   */
  setOptions(options) {
    $.assign(this.options, options)
  }
  /**
   * 
   */
  enable() {
    let { el, options } = this;
    let handle = options.handle || el;
    let index = parseInt(T(el).getStyle('z-index'))
    if (!isNaN(index)) {
      options.zIndex = index;
    }
    el.style.position = 'absolute';
    handle.addEventListener('mousedown', event => {
      event.which === 1 && this.start(event);//ie8- 要用event.button
    });
  }
  /**
   * 开始拖拽
   * @param {*} e 
   * @param {*} el 
   */
  start(e) {
    //地图需禁止拖动
    this.sendToBack();
    let { el } = this;
    DragHandler.el = el;
    this.bringToFront();
    var initialPosition = this.getInitialPosition(el);
    el.cssText = 'position:absolute;margin-left:0;margin-top:0;left:' + inPixels(initialPosition.left) + ';top:' + inPixels(initialPosition.top) + ';'
    el.lastXPosition = e.clientX;
    el.lastYPosition = e.clientY;
    var okToGoOn = this.do('dragstart', { x: initialPosition.left, y: initialPosition.top, oriEvent: e });
    this.addEvents();
  }
  /**
   * 
   * @param {*} el 
   */
  sendToBack() {
    if (DragHandler.el)
      DragHandler.el.style.zIndex = this.options.zIndex - 1;
  }
  /**
   * 
   * @param {*} el 
   */
  bringToFront(el) {
    this.el.style.zIndex = this.options.zIndex;
  }
  /**
   * 添加事件
   */
  addEvents() {
    document.addEventListener('selectstart', this.cancelSelection);
    document.addEventListener('mousemove', this.drag);
    document.addEventListener('mouseup', this.removeEvents);//ie下当离开html之后无法触发mouseup，需监听mouseleave
  }
  /**
   * 获取拖拽前的位置
   * @param {*} el 
   */
  getInitialPosition(el) {
    var rect = {};
    if (T(el).getStyle('position') == 'absolute') {
      rect = { top: el.offsetTop, left: el.offsetLeft };
    } else {
      rect = el.getBoundingClientRect();
    }
    return {
      top: rect.top,
      left: rect.left
    };
  }

  /**
   * cancelDocumentSelection
   * @param {*} event 
   */
  cancelSelection(e) {
    e.preventDefault && e.preventDefault();
    e.stopPropagation && e.stopPropagation();
    e.returnValue = false;
    return false;
  }
  /**
   * 
   * @param {*} e 
   */
  drag(e) {
    let { el } = this;
    e.preventDefault && e.preventDefault();
    e.returnValue = false;
    var style = el.style;
    var elXPosition = parseInt(style.left, 10);
    var elYPosition = parseInt(style.top, 10);
    var offsetX = e.clientX - el.lastXPosition;
    var offsetY = e.clientY - el.lastYPosition;
    //
    var elNewXPosition = elXPosition + (e.clientX - el.lastXPosition);
    var elNewYPosition = elYPosition + (e.clientY - el.lastYPosition);
    // style.left = inPixels(elNewXPosition);
    // style.top = inPixels(elNewYPosition);
    //
    // leaflet 支持
    // 获取原位置
    let point = el._leaflet_pos;
    point.x += offsetX;
    point.y += offsetY;
    //
    DomUtil.setPosition(el, point)
    //
    el.lastXPosition = e.clientX;
    el.lastYPosition = e.clientY;
    //
    this.do('drag', { x: elNewXPosition, y: elNewYPosition, oriEvent: e, offsetX: offsetX, offsetY: offsetY });
  }
  /**
   * 移除监听
   * @param {*} event 
   */
  removeEvents(event) {
    let { el } = this;
    document.removeEventListener('selectstart', this.cancelSelection);
    document.removeEventListener('mousemove', this.drag);
    document.removeEventListener('mouseup', this.removeEvents);
    //
    var left = parseInt(el.style.left, 10);
    var top = parseInt(el.style.top, 10);
    this.do('dragstop', { x: left, y: top, oriEvent: event });
  }
}




// WEBPACK FOOTER //
// ./src/utils/draggable.js